import React from "react";

const TermsServices = () => {
  return (
    <div className="flex justify-center">
      <p className="underline font-semibold text-center">
        Read our{" "}
        <a
          href="https://mathdingo.com/terms_and_conditions.html"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-700"
        >
          Terms
        </a>{" "}
        and{" "}
        <a
          href="https://mathdingo.com/privacy_policy.html"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-700"
        >
          Privacy Policy
        </a>
      </p>
    </div>
  );
};

export default TermsServices;
